@use 'style/utils';

.joy-rating-stars {
    list-style: none;
    padding: 0;
    margin: 0 3px 0 0;
    display: inline-flex;
    align-items: center;

    li {
        margin: 0;
        display: inline-flex;
        align-items: center;

        joy-icon {
            --icon-size: var(--rating-stars-size);
        }
    }

    &--large {
        --rating-stars-size: 17px;
    }

    &--medium {
        --rating-stars-size: 14px;
    }

    &--small {
        --rating-stars-size: 11px;
    }

    &__wrapper {
        display: inline-flex;
        align-items: center;

        span {
            @include utils.getFontProperties(primary-200);
        }

        strong {
            @include utils.getFontProperties(primary-250);
        }
    }
}
